import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import Select from 'react-select';
class TxnTypeFilter extends Component {
    state = {
        txnTypeLists:[],
        txnTypeValue: ""
    };
    componentDidMount(){
        this.getTxnType('current_date');
    }
    resetTxnTypeFilter() {
        this.setState({
            txnTypeValue: "",
        })
    }
    getTxnType(date_type){
        this.setState({
            txnTypeLists:[],
            txnTypeValue: []
        })
        var is_dcc_sale_leg1 = '';
        //alert(date_type)
        if(this.props.is_dcc_sale_leg1) {
            is_dcc_sale_leg1 = this.props.is_dcc_sale_leg1
        }
        axios.get(config.get('API_URL')+'/RefundModule/get-transactions-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                date_type: date_type,
                is_dcc_sale_leg1:is_dcc_sale_leg1
            }
        }).then(response => {
            var txnTypeLists = []
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((txn_type, index) => {
                    txnTypeLists.push({value: txn_type.txn_code, label: txn_type.txn_display_name})
                });
            }
            this.setState({
                txnTypeLists: txnTypeLists
            })
        });

    }

    changeTxnType(optionSelected){
        let value='';
        let txnArray = [];
        if (optionSelected.length < 1) {
            value = null;
            txnArray = ""
        }
        else{
            optionSelected.map((mids, i) => {
                txnArray.push(mids.value)
                // var index = this.state.txnTypeLists.findIndex(obj => obj.value==mids.value);
                // this.state.txnTypeLists.move(index,0).join(',');
            });
        }
        if(txnArray.includes("DCC SALE leg1")===true && txnArray.includes("UPI Leg1")===true) {
            txnArray = txnArray[0];
            optionSelected = [{value: txnArray[0], label: txnArray[0]}];
        }
        if(txnArray.includes("DCC SALE leg1")===true) {
            txnArray = ['DCC SALE leg1'];
            optionSelected = [{value: "DCC SALE leg1", label: "DCC SALE leg1"}];
        }
        if(txnArray.includes("UPI Leg1")===true) {
            txnArray = ['UPI Leg1'];
            optionSelected = [{value: "UPI Leg1", label: "UPI Leg1"}];
        }
        this.props.onSelectTxnType(optionSelected,txnArray);
        this.setState({
            txnTypeValue:optionSelected,
        });

//             const value = optionSelected === null ? '' : optionSelected.value;
//            this.props.onSelectTxnType(optionSelected);
//             this.setState({
//
//                 txnTypeValue:optionSelected,
//             });
    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="txn_type"
                isMulti
                value={this.state.txnTypeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeTxnType.bind(this)}
                options={this.state.txnTypeLists}
                placeholderButtonLabel="Select [Txn Type ]"
            />
        );

    }
}
export default TxnTypeFilter;